import { get } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const getFolderOffers = (documentId, siteId) => {
  return get(`${url}/leasingfolders/${documentId}/${siteId}/folder-offers`);
};

const exp = {
  getFolderOffers
};
export default exp;
